import { useQuery, useMutation } from "@tanstack/react-query";
import { fetch2, fetch3, fetch5, fetch6 } from "../commonApis/commonApis";
const url = process.env.REACT_APP_BASE_URL;

interface ApiResponse {
  success: boolean;
  data: any;
  message?: string;
}

export const useBoxCreateMutation = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res: ApiResponse = await fetch2(`${url}/api/box/`, payload);

      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Box Created successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ Box create request failed:", error.message);
    },
  });
};

export const useFetchBoxData = (
  page: number,
  limit: number,
  searchFor: string,
) => {
  return useQuery({
    queryKey: ["boxData", page, limit, searchFor],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/box?page=${page}&limit=${limit}&searchFor=${searchFor}&type=LM`,
        "get",
      );

      if (!res || !res.data) {
        return res.message;
      }

      return res.data; // 👈 This returns your full user object
    },
    staleTime: 1000 * 60 * 5,
  });
};

interface UpdateBoxesPayload {
  id: string;
  image?: File | string;
  name?: string;
  weight?: string;
  width?: string;
  height?: string;
  length?: string;
  description?: string;
}
export const useUpdateBoxes = () => {
  return useMutation({
    mutationFn: async ({
      id,
      name,
      weight,
      width,
      height,
      description,
      length,
      image,
    }: UpdateBoxesPayload) => {
      const res: ApiResponse = await fetch6(`${url}/api/box/${id}`, {
        name,
        weight,
        width,
        height,
        description,
        length,
        image,
      });

      if (!res.success) {
        throw new Error(res.message || "Failed to update box status");
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Box update successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ Box update request failed:", error.message);
    },
  });
};

// interface UpdateBoxesStatusPayload {
//   id: string;
//   status: string;
// }
// export const useUpdateBoxesStatus = () => {
//   return useMutation({
//   mutationFn: async ({ id, status }: UpdateBoxesStatusPayload) => {
//   const res: ApiResponse = await fetch5(
//     `${url}/api/box/${id}`,
//     "PATCH",
//     { status, forApp: true, forSystem: true },
//   );
// },
//     onSuccess: (data: any) => {
//       console.log("✅ Box status updated successfully:", data);
//     },
//     onError: (error: any) => {
//       console.error("❌ Box status update failed:", error.message);
//     },
//   });
// };

interface UpdateBoxesPayload {
  id: string;
  status?: string;
  forApp?: boolean;
  forSystem?: boolean;
}

export const useUpdateBoxesStatus = () => {
  return useMutation({
    mutationFn: async ({ id, ...payload }: UpdateBoxesPayload) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/box/${id}`,
        "PATCH",
        payload,
      );

      if (!res.success) {
        throw new Error(res.message || "Update failed");
      }

      return res.data;
    },
  });
};
